module.exports = __webpack_public_path__ + "static/media/jenna-ivory-lose.8cc9215a.jpg";